module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAANCAYAAAB/9ZQ7AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAC6ADAAQAAAABAAAADQAAAAAO/q+mAAAAiUlEQVQoFWNgwA4ksAtjigoChZYBMT+6FBO6AJDPAhVjQ5fDphhdDZw/SBQzwx0EYdgDqTwgZgdiayB+DcRPgRgM0N18CCh6Cyp3CUifhLLhlDKQhWwDB5CfCsTIQQcKTiUgZlgCxOogBh6gA5SbD9LBCMTRQPwFiHEBXqAEI0ihAxDLADEh8BAAp8IL4wtLnUUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/downLoad.png
// module id = P2rc
// module chunks = 2